import Vue from 'vue';
import ibanCalculator from './iban-calculator/iban-calculator.vue';
import ibanBoxes from './iban-calculator/iban-boxes';

Vue.component('iban-calculator', ibanCalculator);
Vue.component('iban-boxes', ibanBoxes);
